import { z } from "zod";

export const serverResponse = z.array(
  z.object({
    municipalityId: z.number(),
    municipality: z.string(),
    district: z.string(),
    community: z.string(),
    stateOrProvince: z.string(),
    stateOrProvinceId: z.number(),
    districtId: z.number(),
    communityId: z.number(),
  }),
);
